












































import { Federation, AssociationUtils } from "@/models/Federation";
import { getSortedChildFederations } from "@/utils";
import { Calculation } from "@/models/Calculation";
import { Container } from "@/components";
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "ChildDropdown",
  components: {
    Container,
  },
  props: {
    initialSelectedChild: {
      type: Number,
      default: 0,
    },
    childFederations: {
      type: Array as PropType<Federation[]>,
      required: true,
    },
    childCalculations: {
      type: Array as PropType<Calculation[]>,
      required: true,
    },
    organizations: {
      type: Array as PropType<Federation[]>,
      required: true,
    },
  },
  data() {
    return {
      selectedChildNumber: this.initialSelectedChild,
    };
  },
  watch: {
    selectedChildNumber(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("onChildDropdownChange", newValue);
      }
    },
  },
  methods: {
    customFilter(item: Federation, queryText: string): boolean {
      return AssociationUtils.customFilter(item, queryText);
    },
    getSortedChildFederations() {
      const orgs = getSortedChildFederations(
        this.childFederations,
        this.childCalculations,
        this.organizations
      );

      return orgs;
    },
    isChildActive(nhoNumber: number): boolean {
      const child = this.childCalculations.find((calculation) => {
        return calculation.childNhoNumber === nhoNumber;
      });

      if (child === undefined) return false;
      return child.isActive;
    },
    childExists(nhoNumber: number): boolean {
      return this.childCalculations.some((calculation) => {
        return calculation.childNhoNumber === nhoNumber;
      });
    },
  },
});
